/* @flow */
import GroupStore from 'groups/stores/GroupStore';
import Device from 'entities/Device';
import DeviceActions from 'actions/DeviceActions';
import Dialog from 'components/Dialog.jsx';
import LinkSmsDevicePage from 'user/components/LinkSmsDevicePage.jsx';
import * as React from 'react';

type Props = {
  onRequestHide?: Function,
  onDone?: Function,
  replaceDevice?: Device,
  /* Skip updating device preferences:
   *
   * When adding a new device the backend
   * try to make smart choice about enabling the added device
   * and disabeling preixisting one. This skips it, the added
   * device will be disabled, and current devices will not change.
   */
  skipUpdateDevicePreferences?: boolean,
  // This prop is true when the user reaches this modal when they attempt
  // to make a phone call
  userMakingACall?: boolean,
};

class LinkSmsDeviceModal extends React.Component<Props> {
  handleDone = () => {
    // The API delete the old sms device when we verify a new one,
    // hence we only have to do a local delete to remove from the store.
    if (this.props.replaceDevice) {
      DeviceActions.localDelete(this.props.replaceDevice);
    }

    // we might have new subscriptions!
    GroupStore.invalidate();
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
    // callback from parent
    if (this.props.onDone) {
      this.props.onDone();
    }
  };

  render() {
    return (
      <Dialog size="small" {...this.props} box={false} hideCloseButton>
        <LinkSmsDevicePage
          closable
          onDone={this.handleDone}
          onRequestHide={this.props.onRequestHide}
          skipUpdateDevicePreferences={this.props.skipUpdateDevicePreferences}
          userMakingACall={this.props.userMakingACall}
        />
      </Dialog>
    );
  }
}

export default LinkSmsDeviceModal;
